import { render, staticRenderFns } from "./modifyAuth.vue?vue&type=template&id=10a4773a&scoped=true"
import script from "./modifyAuth.vue?vue&type=script&lang=js"
export * from "./modifyAuth.vue?vue&type=script&lang=js"
import style0 from "./modifyAuth.vue?vue&type=style&index=0&id=10a4773a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a4773a",
  null
  
)

export default component.exports